import { computed } from 'vue';
import { localStorageService } from '@/core/browser/storage.service';
import generateCdnUrlWithParams from '@/core/responsive/image/helpers/generate-cdn-url-including-params';
import generateCdnUrlWithoutParams from '@/core/responsive/image/helpers/generate-cdn-url-excluding-params';

export default function usePressMode() {
    const pressModeKey = 'pressModeActive'; // keep in sync with press.service.ts in AngularJS solution

    const isActive = computed(() => {
        return localStorageService.getItem(pressModeKey) === 'true';
    });

    const getPressQualityImageUrl = (imageUrl: string, isProductImage, cacheBust: string) => {
        if (isProductImage) {
            return generateCdnUrlWithParams(
                imageUrl,
                { format: 'auto', width: 4000, height: 4000 },
                true);
        }

        return generateCdnUrlWithoutParams(
            imageUrl,
            { cacheBust: cacheBust },
            false);
    };

    return {
        isActive,
        getPressQualityImageUrl,
    };
}
